import { ActionType, createAction } from 'typesafe-actions'

import { UserProfileData } from './types'

export const AccountUserActions = {
  fetchUserData: createAction('ACCOUNT-USER/load-data')(),
  setData: createAction('ACCOUNT-USER/set-data')<UserProfileData>(),
  fetchBillingData: createAction('ACCOUNT-USER/load-billing')(),
  setBillingData: createAction('ACCOUNT-USER/set-billing-data')<UserProfileData['accounting']>(),
  fetchUserAndBillingData: createAction('ACCOUNT-USER/fetch-user-billing-data')()
}

export type AccountUserActions = ActionType<typeof AccountUserActions>
